import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as moment from "moment";
@Component({
  selector: 'app-daily-spend',
  templateUrl: './daily-spend.component.html',
  styleUrls: ['./daily-spend.component.css']
})
export class DailySpendComponent {

  @Output() idlist = new EventEmitter<any[]>();
  @Input("dailyspendRes") dailyspendRes: any;
  @Input("isspendRes") isdailyspendRes: any;
  @Input("dsAll") dsAll: any;
  @Output() idlistdailycost = new EventEmitter<any[]>();
  currentPage: number = 1;
  itemsPerPage: number = 10;
  idLis:any=[];
  idlistdcost:any = [];
  isallselect=false;
  constructor(
  
  ) {}

  ngOnInit(): void {

  };




  get totalPages(): number {
    return Math.ceil(this.dailyspendRes.length / this.itemsPerPage);
  }
  getItemsForPage(pageNumber: number): any[] {
    const startIndex = (pageNumber - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.dailyspendRes.slice(startIndex, endIndex);
  }

  navigateToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }
  navigateToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }
  // getPageNumbers(): number[] {
  //   return Array(this.totalPages)
  //     .fill(0)
  //     .map((_, i) => i + 1);
  // }

  navigateToPage(page: number | '...') { if (page !== '...') { this.currentPage = page as number; } } 
  getPageNumbers(): (number | "...")[] {
    const totalPageCount = this.totalPages;
    const maxVisiblePages = 5;
    let start = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
    let end = Math.min(start + maxVisiblePages - 1, totalPageCount);
    start = Math.max(1, end - maxVisiblePages + 1);
    const pageNumbers: (number | "...")[] = [];
    for (let i = start; i <= end; i++) {
      pageNumbers.push(i);
    }
    if (start > 1) {
      pageNumbers.unshift("...");
    }
    if (end < totalPageCount) {
      pageNumbers.push("...");
    }
    return pageNumbers;
  }

  fixedDecimal(input: string): string {
    const regex = /(\d+\.\d+)/g;
    const formattedString = input.replace(regex, (match) => {
      return parseFloat(match).toFixed(2);
    });
    return formattedString;
  }

  // markAll() {
  //   const areAllSelected = this.dailyspendRes.every((item: any) => item.check);
  //   this.dailyspendRes.forEach((item: any) => {
  //     item.check = !areAllSelected;
  //     if (!areAllSelected && !this.idLis.includes(item.id) && item.status==='incomplete') {
  //       this.idLis.push(item.id);
  //     } else if (areAllSelected) {
  //       this.idLis = this.idLis.filter((id: any) => id !== item.id);
  //     }
  //   });
  //   this.idlist.emit(this.idLis);
  // }
  markAll() {
    const areAllSelected = this.dailyspendRes.every((item: any) => item.check);
    this.dailyspendRes.forEach((item: any) => {
      item.check = !areAllSelected;
    if(item.type === undefined){
      if (
        !areAllSelected &&
        !this.idLis.includes(item.id) &&
        item.status === "incomplete"
      ) {
        this.idLis.push(item.id);
      } else if (areAllSelected) {
        this.idLis = this.idLis.filter((id: any) => id !== item.id);
      }
    }else if(item.type==='dailyCost'){
      if (
        !areAllSelected &&
        !this.idlistdcost.includes(item.id) &&
        item.status === "incomplete"
      ) {
        this.idlistdcost.push(item.id);
      } else if (areAllSelected) {
        this.idlistdcost = this.idlistdcost.filter((id: any) => id !== item.id);
      }
    }
    });
    this.idlist.emit(this.idLis);
    this.idlistdailycost.emit(this.idlistdcost);
  }

  updateStatus(id: any,type:any) {
    if(type===undefined){
 const index = this.idLis.indexOf(id);
    if (index === -1) {
      this.idLis.push(id);
    } else {
      this.idLis.splice(index, 1);
    }
    this.idlist.emit(this.idLis);
    }
    else if(type==='dailyCost'){
      const index = this.idlistdcost.indexOf(id);
      if (index === -1) {
        this.idlistdcost.push(id);
      } else {
        this.idlistdcost.splice(index, 1);
      }
     this.idlistdailycost.emit(this.idlistdcost);
    }
  }

  formatDate(date: any): any {
    if (date !== "") {
      return  moment.utc(date, 'YYYY-MM-DDTHH:mm:ss').local().format('MMM DD, YYYY hh:mm A');
    }
    return "";
  }
}
